import BlonvilleSeptember2026 from "../../components/before-after/BlonvilleSeptember2026";

const BlonvilleSeptember2026View = () => {

    return (
        <div className="before-after-blonville-september-2026">
            <BlonvilleSeptember2026/>
        </div>
    );
};

export default BlonvilleSeptember2026View;
